// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let AssessmentEditor
window.sortable = require("jquery-ui/sortable")

const AssessmentConfigView =
  require("assessments/admin/views/assessment-config").default

const Question = require("assessments/models/question").default
const QuestionOrderUpdate =
  require("assessments/models/question-order-update").default
const QuestionCard = require("assessments/show/views/question-card").default

export default AssessmentEditor = (function () {
  AssessmentEditor = class AssessmentEditor extends (
    require("lib/static-shim").default(
      require("lib/core/composite-view").default
    )
  ) {
    constructor(...args) {
      super(...args)
      this.onAssessmentSaved = this.onAssessmentSaved.bind(this)
      this.updateQuestionOrder = this.updateQuestionOrder.bind(this)
    }

    static initClass() {
      this.prototype.template = require("./templates/assessment-editor.html")
      this.prototype.childViewContainer = ".assessment-questions"
      this.prototype.childView = require("./editable-question").default

      this.prototype.events = { "click li.question.view": "showQuestion" }

      this.prototype.ui = {
        questionList: ".assessment-questions",
        config: ".assessment-config-container"
      }

      this.prototype.modelEvents =
        // Create an add item after the assessment is first saved
        {
          "change:id"() {
            return this.createAddItem()
          }
        }
    }

    initialize() {
      this.collection = this.model.questions

      this.listenTo(this.collection, "remove", function () {
        return _.defer(() => {
          return this.updateQuestionOrder()
        })
      })

      this.listenTo(this.collection, "sync", function () {
        this.createAddItem()
        return this.updateQuestionOrder()
      })

      if (!this.model.isNew() && !this.collection.length) {
        this.collection.fetch()
      } else if (this.collection.length > 0) {
        this.createAddItem()
      }

      this.listenTo(this.model, "sync", this.onAssessmentSaved)
      this.listenTo(this.model, "sync", this.onAssessmentSync)
      return this.listenTo(this.collection, "sync", this.onAssessmentSync)
    }

    onAssessmentSync() {
      if (this.options != null ? this.options.onSave : undefined) {
        return this.options.onSave(this.model, this.collection)
      }
    }

    onAssessmentSaved(assessment, resp, ops) {
      this.configView.render()
      this.ui.questionList.toggle(!this.model.isNew())
      if (!this.collection.length) {
        return this.collection.fetch()
      }
    }

    onRender() {
      // Render Configuration
      this.configView = new AssessmentConfigView({ model: this.model })
      this.ui.config.html(this.configView.render().el)
      this.initQuestionUI()
      return this.ui.questionList.toggle(!this.model.isNew())
    }

    onDestroy() {
      this.configView.destroy()
      return this.ui.questionList.sortable("destroy")
    }

    initQuestionUI() {
      // Called after the question collection is loaded...
      return this.ui.questionList.sortable({
        items: "li:not(.new)",
        handle: ".move",
        placeholder: "placeholder",
        forcePlaceholderSize: true,
        helper: "clone",
        update: (e, ui) => {
          return this.updateQuestionOrder()
        }
      })
    }

    showQuestion(e) {
      e.preventDefault()
      const q = this.collection.get($(e.currentTarget).data().id)
      const card = new QuestionCard({ model: q, assessment: this.model })
      return Pathwright.execute("show:modal", card, {
        appendClass: "question-card-modal"
      })
    }

    // onShow: ->
    //   if not @model.isNew()
    //     @createAddItem()

    createAddItem() {
      if (this.$(".question.new").length) {
        return
      }
      const newQ = new Question({
        state: "new",
        skipValidation: true,
        order: this.collection.nextOrder(),
        assessment: this.model.id
      })
      return this.collection.add(newQ)
    }

    updateQuestionOrder() {
      const orderUpdates = []

      this.ui.questionList.find("> li:not(.new)").each((i, li) => {
        const order = i + 1
        const qid = $(li).data("id")

        const q = this.collection.get(qid)
        if (q != null && q.get("order") !== order) {
          q.set({ order, skipValidation: true })
          q.set({ skipValidation: false })
          return orderUpdates.push({ id: q.id, order: q.get("order") })
        }
      })

      if (orderUpdates.length) {
        const data = {
          assessment_id: this.model.id,
          updates: orderUpdates
        }

        const updates = new QuestionOrderUpdate(data)
        return updates
          .save()
          .then(() => this.collection.trigger("sync")) // manually trigger to fire event
          .fail((err) => console.error(err))
      }
    }
  }
  AssessmentEditor.initClass()
  return AssessmentEditor
})()
